<template>
  <div class="bar-chart">
    <div class="bar-chart__background">
      <div
        class="bar-chart__inner-bar"
        :class="'bar-chart__color-' + barColor"
        :style="{ width: percent + '%' }"
        @click="onBarClick"
      >
        <md-tooltip md-direction="top">
          Clique para exibir as ordens de
          <br />
          serviço que estão nesse status
        </md-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BarChart',
  props: {
    percent: {
      type: Number,
      default: 0,
    },
    barColor: {
      type: String,
      default: 'blue',
    },
    action: {
      type: String,
    },
  },
  methods: {
    onBarClick() {
      this.$emit('clicked', this.action)
    },
  },
}
</script>

<style lang="scss" scoped>
.bar-chart {
  width: 120%;
  padding-bottom: 16px;

  &__background {
    background: transparent;
    border-radius: 3px;
    width: 100%;
    height: 50px;
  }

  &__inner-bar {
    height: 100%;
    border-radius: 3px;
    max-width: 100%;
    cursor: pointer;
  }

  &__color {
    &-blue {
      background-color: #00b5cc;
      &:hover {
        background-color: #0097aa;
        border: 2px solid #0097aa;
      }
    }
    &-yellow {
      background-color: #f2994a;
      &:hover {
        background-color: #f0872a;
        border: 2px solid #f0872a;
      }
    }
    &-cornflower {
      background-color: #7399e5;
      &:hover {
        background-color: #5e85df;
        border: 2px solid #5e85df;
      }
    }
    &-green {
      background-color: #55cd9e;
      &:hover {
        background-color: #3bc58f;
        border: 2px solid #3bc58f;
      }
    }
    &-red {
      background-color: #BC293A;
      &:hover {
        background-color: #8e1b29;
        border: 2px solid #8e1b29;
      }
    }
  }
}
</style>
